import * as React from "react";

import { cn } from "./utils";

const Textarea = React.forwardRef<HTMLTextAreaElement, React.ComponentProps<"textarea">>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        data-slot="textarea"
        className={cn(
          "resize-none flex min-h-16 w-full rounded-md px-3 py-2 text-base transition-colors outline-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          "bg-white border border-gray-200",
          "hover:border-gray-300",
          "focus:outline-none focus:border-primary/20 focus:ring-1 focus:ring-primary/20",
          "placeholder:text-muted-foreground",
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Textarea.displayName = "Textarea";

export { Textarea };
